// extracted by mini-css-extract-plugin
export default {"danger":"MilestoneDescription-module__danger__re_tqa6","subtle":"MilestoneDescription-module__subtle__p2CBryn"};